const RouterRedirect = () => import( /* webpackChunkName: "open-shop" */ 'viralstyle-ui/src/VsRouterRedirect');

const Terms = () => import( /* webpackChunkName: "legal" */ './Terms'),
  PrivacyPolicy = () => import( /* webpackChunkName: "legal" */ './PrivacyPolicy'),
  CookiePolicy = () => import( /* webpackChunkName: "legal" */ './CookiePolicy'),
  Partnerships = () => import( /* webpackChunkName: "static" */ './Partnerships'),
  About = () => import( /* webpackChunkName: "static" */ './About'),
  Careers = () => import( /* webpackChunkName: "static" */ './Careers'),
  FAQ = () => import( /* webpackChunkName: "static" */ './FAQ'),
  OpenShopOverview = () => import( /* webpackChunkName: "open-shop" */ './open-shop/OpenShopOverview'),
  OpenShopCreators = () => import( /* webpackChunkName: "open-shop" */ './open-shop/OpenShopCreators'),
  OpenShopArtists = () => import( /* webpackChunkName: "open-shop" */ './open-shop/OpenShopArtists'),
  OpenShopEsports = () => import( /* webpackChunkName: "open-shop" */ './open-shop/OpenShopEsports'),
  OpenShopMusicians = () => import( /* webpackChunkName: "open-shop" */ './open-shop/OpenShopMusicians'),
  OpenShopNonprofits = () => import( /* webpackChunkName: "open-shop" */ './open-shop/OpenShopNonprofits');

export default [{
  path: '/about-us',
  component: About,
  name: 'about',
}, {
  path: '/careers',
  component: Careers,
  name: 'careers',
}, {
  path: '/privacy/cookies',
  component: CookiePolicy,
  name: 'cookies',
}, {
  path: '/faq',
  component: FAQ,
  name: 'faq',
}, {
  path: '/partnership',
  component: Partnerships,
  name: 'partnerships',
}, {
  path: '/privacy',
  component: PrivacyPolicy,
  name: 'privacy',
}, {
  path: '/terms',
  component: Terms,
  name: 'terms',
}, {
  path: '/open-shop',
  component: RouterRedirect,
  name: 'openShop',
  redirect: '/open-shop/overview',
  children: [{
    name: 'openShopOverview',
    path: '/open-shop/overview',
    component: OpenShopOverview,
  }, {
    name: 'openShopCreators',
    path: '/open-shop/creators',
    component: OpenShopCreators,
  }, {
    name: 'openShopArtists',
    path: '/open-shop/artists',
    component: OpenShopArtists,
  }, {
    name: 'openShopEsports',
    path: '/open-shop/esports',
    component: OpenShopEsports,
  }, {
    name: 'openShopMusicians',
    path: '/open-shop/musicians',
    component: OpenShopMusicians,
  }, {
    name: 'openShopNonprofits',
    path: '/open-shop/nonprofits',
    component: OpenShopNonprofits,
  }],
}, ];